
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _ = require('lodash');
var withPureRender = require('./withPureRender');
var withTranslation = require('./withTranslation');
var withUtils = require('./withUtils');
// const withProfiling = require('./withProfiling')

//TODO: remove eslint ignore when fixed
/* eslint lodash/prefer-times:0 */
module.exports = function (Component) {
    var extraWrappers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var composed = _.flowRight.apply(_, [
    // withProfiling,
    withPureRender, withTranslation, withUtils].concat(_toConsumableArray(extraWrappers)))(Component);
    composed._rawClass = Component;
    composed.getDisplayName = function () {
        return Component.displayName;
    };
    return composed;
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/hoc/compose.js